import { jsx, jsxs } from "react/jsx-runtime";
import { useGraphiQLActions, useGraphiQL } from "../provider.js";
import { KeycapHint } from "../keycap-hint/index.js";
/* empty css          */
const TopBar = ({
  endpointUrl,
  version
}) => {
  const {
    run
  } = useGraphiQLActions();
  const isFetching = useGraphiQL((state) => state.isFetching);
  return /* @__PURE__ */ jsx(TopBarView, { endpointUrl, version, isFetching, onRun: run });
};
const TopBarView = ({
  endpointUrl,
  version,
  isFetching,
  onRun
}) => {
  return /* @__PURE__ */ jsxs("header", { className: "graphiql-top-bar", role: "banner", children: [
    /* @__PURE__ */ jsxs("div", { className: "graphiql-top-bar-brand", children: [
      /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-logo", "aria-hidden": "true" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-wordmark", children: "GraphiQL" }),
      version && /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-version", children: version })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "graphiql-top-bar-divider", "aria-hidden": "true" }),
    /* @__PURE__ */ jsxs("div", { className: "graphiql-top-bar-endpoint", children: [
      /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-endpoint-method", children: "POST" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-top-bar-endpoint-url", children: endpointUrl ?? "/graphql" })
    ] }),
    /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-top-bar-cmd", children: [
      /* @__PURE__ */ jsx("span", { children: "Jump to schema" }),
      /* @__PURE__ */ jsx(KeycapHint, { keys: ["⌘", "K"], ariaLabel: "Open command palette" })
    ] }),
    /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-top-bar-run", onClick: onRun, disabled: isFetching, "aria-label": "Run query", children: [
      "Run",
      /* @__PURE__ */ jsx(KeycapHint, { keys: ["⌘", "⏎"], ariaLabel: "Run query shortcut" })
    ] })
  ] });
};
export {
  TopBar,
  TopBarView
};
//# sourceMappingURL=index.js.map
